import React from 'react';

// Maps the 10 tender status values onto the 12-stage lifecycle so we can render
// a compact "Stage N/12 · LABEL" pill plus a horizontal progress bar in dashboards.
const STATUS_TO_STAGE = {
  draft: { num: 1, label: 'Draft', color: 'bg-gray-400' },
  pending_approval: { num: 1, label: 'Internal Approval', color: 'bg-yellow-500' },
  approved: { num: 2, label: 'Ready to Publish', color: 'bg-navy/50' },
  published: { num: 4, label: 'Open for Bids', color: 'bg-navy' },
  under_committee_review: { num: 6, label: 'Committee Review', color: 'bg-gold' },
  awarded: { num: 7, label: 'Awarded', color: 'bg-green-600' },
  po_issued: { num: 8, label: 'PO Issued', color: 'bg-orange' },
  work_completed: { num: 9, label: 'Work Completed', color: 'bg-orange' },
  noc_issued: { num: 10, label: 'NOC Received', color: 'bg-orange' },
  closed: { num: 12, label: 'Closed', color: 'bg-green-700' },
};

const TOTAL_STAGES = 12;

const LifecycleProgressBadge = ({ status, compact = false }) => {
  const stage = STATUS_TO_STAGE[status] || STATUS_TO_STAGE.draft;
  const pct = Math.round((stage.num / TOTAL_STAGES) * 100);
  const testid = `lifecycle-badge-${status}`;

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase" data-testid={testid}>
        <span className={`w-1.5 h-1.5 rounded-full ${stage.color}`} />
        {stage.num}/{TOTAL_STAGES}
      </span>
    );
  }

  return (
    <div className="min-w-[140px]" data-testid={testid}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] font-bold uppercase tracking-wide text-navy">Stage {stage.num}/{TOTAL_STAGES}</span>
        <span className="text-[10px] text-muted-foreground">{pct}%</span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
        <div className={`h-full ${stage.color} transition-all`} style={{ width: `${pct}%` }} />
      </div>
      <div className="text-[10px] mt-1 text-foreground/80 font-medium">{stage.label}</div>
    </div>
  );
};

export default LifecycleProgressBadge;
